module.exports = __webpack_public_path__ + "img/arrow-bottom.2fda26a4.svg";